import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=d96e9d54&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=d96e9d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e9d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d96e9d54')) {
      api.createRecord('d96e9d54', component.options)
    } else {
      api.reload('d96e9d54', component.options)
    }
    module.hot.accept("./BasicInfo.vue?vue&type=template&id=d96e9d54&scoped=true&", function () {
      api.rerender('d96e9d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/submit-application/components/BasicInfo.vue"
export default component.exports